import { useSelector } from 'react-redux';
import { useFeatureFlag } from 'configcat-react';

import { getDataNavBarByDeviceShowing, getDataNavbarMerged } from '../helpers';

import { SHOW_SALES_MANAGEMENT, type MenuItens, type RootState, type UtilLinks } from 'core';

import { useGetFeatureFlag } from 'ui/hooks';

export const useGetDataNavBar = () => {
  const {
    data: { resellerId },
  } = useSelector((state: RootState) => state.user);
  const { value: objConfigMenu } = useFeatureFlag('showBadgeNotificationMenu', '{}');
  const { value: showSalesManagement } = useGetFeatureFlag(
    SHOW_SALES_MANAGEMENT,
    false,
    resellerId,
  );

  const getDataNavBar = (data: MenuItens, isMobile: boolean) => {
    let menuLinks: UtilLinks[];
    if (!data) return [];

    const { links } = data;

    menuLinks = getDataNavbarMerged(links, objConfigMenu);
    if (!showSalesManagement) {
      const newLinks = links.filter((link) => !link.to.toLowerCase().includes('gestao'));

      menuLinks = getDataNavbarMerged(newLinks, objConfigMenu);
    }

    return getDataNavBarByDeviceShowing(menuLinks, isMobile);
  };

  return {
    getDataNavBar,
  };
};
